import { Link } from '@inertiajs/react'

export default function CreditsWidget({ credits }) {
  const isLow = credits.low_credits
  const percentage = (credits.balance / credits.alert_threshold) * 100

  return (
    <Link
      href="/credits"
      className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow cursor-pointer"
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-600">Crédits</h3>
        <div className={`w-10 h-10 rounded-lg ${
          isLow ? 'bg-red-50 text-red-600' : 'bg-green-50 text-green-600'
        } flex items-center justify-center text-xl`}>
          💳
        </div>
      </div>

      <div className="text-3xl font-bold text-gray-900 mb-2">{credits.balance}</div>

      {isLow && (
        <div className="mb-3">
          <div className="flex items-center gap-2 text-sm text-red-600 font-medium mb-2">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            Crédits faibles
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className={`h-2 rounded-full ${isLow ? 'bg-red-600' : 'bg-green-600'}`}
              style={{ width: `${Math.min(percentage, 100)}%` }}
            />
          </div>
        </div>
      )}

      <p className="text-sm text-gray-600">
        Seuil d'alerte : {credits.alert_threshold}
      </p>
    </Link>
  )
}
